import React, {
  useContext,
  useState,
  Fragment,
  Suspense,
  lazy,
  useEffect,
} from "react";

import { useHistory } from "react-router-dom";
import { Menu, MenuList, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react-lite";
import { playerStoreContext } from "lib/player_store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getToken } from "lib/ajax";

const LogInModal = lazy(() =>
  import(/* webpackChunkName: "login" */ "../modals/LogIn")
);

const SignUpModal = lazy(() =>
  import(/* webpackChunkName: "signup" */ "../modals/SignUp")
);

const useStyles = makeStyles((_theme) => ({
  paper: {
    backgroundColor: "#152f50",
    "& li": {
      color: "#fff",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.1)",
      },
    },
  },
}));

const UserMenu = observer(() => {
  const store = useContext(playerStoreContext);
  const history = useHistory();
  const { user_id, logInOpen, signUpOpen } = store;

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("signup") == "1") {
      store.setSignUpOpen(true);
    } else if (urlParams.get("login") == "1") {
      store.setLogInOpen(true);
    }
  }, []);

  const setClose = () => {
    setAnchorEl(null);
    //  setState({ open: false });
  };

  const setOpen = (e) => {
    setAnchorEl(e.currentTarget);
    // setState({ open: true, anchorEl: e.currentTarget });
  };

  // const popme = () => {
  //   _jangoGuest.popme();
  // };

  // const popme_login = () => {
  //   _jangoGuest.popme_login();
  // };

  const logout = (event) => {
    var f = document.createElement("form");
    f.style.display = "none";
    document.body.appendChild(f);
    f.method = "POST";
    f.action = "/users/" + "logout";

    var m = document.createElement("input");
    m.setAttribute("type", "hidden");
    m.setAttribute("name", "_method");
    m.setAttribute("value", "delete");
    f.appendChild(m);

    var t = getToken();
    if (t) {
      var mm = document.createElement("input");
      mm.setAttribute("type", "hidden");
      mm.setAttribute("name", "authenticity_token");
      mm.setAttribute("value", t);
      f.appendChild(mm);
    }

    f.submit();
    try {
      event.stopPropagation();
    } catch (e) {}
    return false;
  };

  const nav = (value) => {
    return history.push(value);
    // return Turbo;links.visit(value);
  };

  const handleClick = (value) => (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    if (value === null) {
      return;
    }
    switch (value) {
      case "logout": {
        logout();
        break;
      }
      case "signup": {
        store.setSignUpOpen(!signUpOpen);
        setAnchorEl(false);

        break;
      }
      case "login": {
        store.setLogInOpen(!logInOpen);
        setAnchorEl(false);

        break;
      }
      case "email": {
        window.open(`/users/${user_id}/emails`, "_email");

        break;
      }
      default: {
        setAnchorEl(false);
        nav(value);
        break;
      }
    }

    return false;
  };

  // render() {
  //   const trigger = (
  //     <div
  //       style={{
  //         padding: "0px 10px",
  //         minHeight: "50px",
  //         lineHeight: "50px",
  //       }}
  //     >
  //       <Icon
  //         key="um_usercircle"
  //         name="user circle outline"
  //         className="inverted"
  //         size="large"
  //         style={{ marginRight: 0 }}
  //       />
  //       <Icon
  //         key="um_downcaret"
  //         name="down caret"
  //         className="inverted"
  //         size="small"
  //       />
  //     </div>
  //   );

  let menu_items = [];
  if (user_id > 0) {
    menu_items = menu_items.concat([
      {
        key: "fan_mail",
        text: "Artist Messages",
        value: "email",
      },
      {
        key: "settings",
        text: "Settings",
        value: `/users/${user_id}/account`,
      },
      {
        key: "edit_profile",
        text: "Edit Profile",
        value: `/users/${user_id}/about`,
      },
      {
        key: "view_profile",
        text: "View Profile",
        value: `/users/${user_id}`,
      },
      {
        key: "um_logouter",
        text: "Log Out",
        value: "logout",
        // onClick: logout,
      },
    ]);
  } else {
    menu_items = menu_items.concat([
      {
        key: "um_signup",
        text: "Sign Up",
        value: "signup",
        // onClick: () => {
        //   store.setSignUpOpen(!signUpOpen);
        // },
      },
      {
        key: "um_login",
        text: "Log In",
        value: "login",
        // onClick: () => {
        //   store.setLogInOpen(!logInOpen);
        // },
      },
    ]);
  }

  const dismissLogIn = () => {
    store.setLogInOpen(false);
  };
  const dismissSignUp = () => {
    store.setSignUpOpen(false);
  };

  return (
    <Fragment>
      <FontAwesomeIcon
        icon="user-circle"
        className="icon-action"
        onClick={setOpen}
      />
      <Menu
        disableScrollLock={true}
        classes={{ paper: classes.paper }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={setClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuList>
          {menu_items.map((h) => {
            return (
              <MenuItem
                key={h.key}
                value={h.value}
                onClick={handleClick(h.value)}
              >
                {h.text}
              </MenuItem>
            );
          })}
        </MenuList>
      </Menu>
      <Suspense fallback={null}>
        {user_id == 0 && logInOpen && (
          <LogInModal open={logInOpen} dismiss={dismissLogIn} />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {user_id == 0 && signUpOpen && (
          <SignUpModal open={signUpOpen} dismiss={dismissSignUp} />
        )}
      </Suspense>
    </Fragment>
  );
});

export default UserMenu;
